import React from 'react';
import { locales } from '../../translations/locales';

const ButtonDisconnect = (props) => {
    const { session, locale, theme } = props;

    return (
        <div className={`buttonDisconnect mt-5 b-${theme === 'DARK' ? 'dark' : 'light'}`}>
            <span onClick={() => session.disconnect()}>
                {locales[locale].disconnect}
            </span>
        </div>
    );
};

export default ButtonDisconnect;
